import { Box, Grid } from '@mui/material'

import { SlideType } from '../../../../_types'

export interface GridSlideSelectorProps {
  slides: SlideType[]
  onSlideSelect: (index: number) => void
  activeIndex: number
}
export const GridSlideSelector: React.FC<GridSlideSelectorProps> = ({
  slides,
  activeIndex,
  onSlideSelect,
}) => {
  const handleSlideSelect = (idx: number) => () => onSlideSelect(idx)
  return (
    <Grid
      container
      spacing={{ xs: 3, md: 3 }}
      columns={5}
      justifyContent="center"
    >
      {slides.map((s: SlideType, idx: number) => {
        return (
          <Grid item key={s?.id || idx}>
            <Box
              sx={{
                minWidth: '200px',
                minHeight: '80px',
                cursor: s?.index !== activeIndex ? 'pointer' : 'default',
              }}
              onClick={handleSlideSelect(s?.index)}
            >
              <Box
                sx={{
                  position: 'relative',
                  left: '-5px',
                  top: '5px',
                  backgroundColor:
                    s?.index === activeIndex ? 'orange' : 'black',
                  color: 'white',
                  // color: s?.index === activeIndex ? 'black' : 'white',
                  opacity: s?.index === activeIndex ? 0.8 : 0.6,
                  borderRadius: '6px',
                  paddingX: '6px',
                  fontSize: '12px',
                  width: '30px',
                  paddingLeft: '2px',
                  paddingRight: '2px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  fontWeight: 'bolder',
                  zIndex: 100
                }}
              >
                {s?.index + 1}
              </Box>
              <Box
                sx={{
                  opacity: s?.index === activeIndex ? 0.5 : 1,
                }}
              >
                <img width="200px" src={s.imgSrc} alt="" />
              </Box>
            </Box>
          </Grid>
        )
      })}
    </Grid>
  )
}

export default GridSlideSelector
